import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d937a21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute" }
const _hoisted_2 = {
  key: 0,
  "background-color": "red-65"
}
const _hoisted_3 = { class: "white-text" }
const _hoisted_4 = { class: "profile-section-back-foreground" }
const _hoisted_5 = {
  class: "mt-3",
  "data-testid": "address"
}
const _hoisted_6 = {
  key: 0,
  class: "sliced-address"
}
const _hoisted_7 = {
  key: 0,
  class: "tags-wrapper mt-2"
}
const _hoisted_8 = {
  key: 2,
  class: "mt-4",
  "data-testid": "app-balance"
}
const _hoisted_9 = { class: "profile-balance" }
const _hoisted_10 = {
  class: "amount is-flex is-align-items-center",
  "data-testid": "amount"
}
const _hoisted_11 = { class: "icon-button" }
const _hoisted_12 = { class: "symbol ml-2" }
const _hoisted_13 = { class: "profile-section-back-header" }
const _hoisted_14 = { class: "profile-wrapper" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  class: "bio-wrapper",
  "data-testid": "description"
}
const _hoisted_18 = { class: "bio" }

import { useRouter } from 'vue-router'
import { ref, onUnmounted, computed, onMounted, watchEffect } from 'vue'

import ProfilePicture from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import ProfileBackground from '@/popup/components/shared/ProfileBackground/ProfileBackground.vue'
import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'
import UserName from '@/popup/components/shared/Miscellaneous/UserName.vue'
import UPWebsiteLink from '@/popup/components/shared/Miscellaneous/UPWebsiteLink.vue'
import Tooltip from '@/popup/components/shared/Tooltip/Tooltip.vue'
import { useAppStore } from '@/popup/store/AppStore'
import { useUIStore } from '@/popup/store/UIStore'
import { truncateMiddle } from '@/shared/utils'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import { openInExternalPopup } from '@/popup/utils/openExternalPopup'
import TestnetLabel from '@/popup/components/shared/TestnetLabel.vue'
import FormattedTokenAmount from '@/popup/components/shared/FormattedTokenAmount.vue'
import { usePreferencesStore } from '@/popup/store/PreferencesStore'
import { useProfileStore } from '@/popup/store/ProfileStore'
import Skeleton from '@/popup/components/shared/Skeleton.vue'
import { ControlLevel } from '@/business-logic/profile'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCard',
  setup(__props) {

const flipTimeout = ref<number>()
const preferencesStore = usePreferencesStore()
const appStore = useAppStore()
const uiStore = useUIStore()
const profileStore = useProfileStore()
const router = useRouter()
const { getWeb3Eth } = useWeb3Eth()
const { getBalance } = getWeb3Eth()

const balance = ref('')
const isTokenBalanceLoading = ref<boolean>(true)
const currentProfile = computed(() => appStore.currentProfile)
const isCardFlipped = computed(() => uiStore.flipped)

const readOnlyMode = computed(() => {
  if (!profileStore.deviceController) {
    return true
  }
  return (
    profileStore.deviceController.permissions.controlLevel === ControlLevel.None
  )
})

const coverPictureClasses = computed(() =>
  currentProfile.value.coverPicture
    ? {
        lightBoxShadow: '',
        backdropFilter: 'backdrop-filter',
      }
    : {
        lightBoxShadow: 'light-box-shadow',
        backdropFilter: '',
      }
)

const clickFlip = () => {
  uiStore.setCardFlipped(true)
}

const hoverFlip = () => {
  flipTimeout.value = window.setTimeout(
    () => uiStore.setCardFlipped(true),
    1000
  )
}

const flipOff = () => {
  clearInterval(flipTimeout.value)
  uiStore.setCardFlipped(false)
}

const openEditProfile = async () => openInExternalPopup(router, 'edit-profile')

onMounted(async () => {
  if (currentProfile.value) {
    balance.value = currentProfile.value.address
      ? await getBalance(currentProfile.value.address)
      : ''
    isTokenBalanceLoading.value = false
  }
})

watchEffect(async () => {
  if (currentProfile.value) {
    balance.value = currentProfile.value.address
      ? await getBalance(currentProfile.value.address)
      : ''
  }
})

const toast = computed(() => uiStore.toast)

watchEffect(async () => {
  if (toast.value && toast.value.background === 'success') {
    isTokenBalanceLoading.value = true
    balance.value = currentProfile.value.address
      ? await getBalance(currentProfile.value.address)
      : ''
    isTokenBalanceLoading.value = false
  }
})

onUnmounted(() => {
  clearTimeout(flipTimeout.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`flip-box ${isCardFlipped.value ? 'flipped' : ''}`),
    "data-testid": "flip-box",
    onClick: clickFlip,
    onMouseenter: hoverFlip,
    onMouseleave: flipOff
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flip-box-inner", currentProfile.value.coverPicture ? '' : 'no-cover-picture'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["profile-section flip-box-front", coverPictureClasses.value.lightBoxShadow])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(SvgIcon, {
            key: String(currentProfile.value.coverPicture),
            height: "24",
            width: "24",
            name: "qr-code",
            color: 
              currentProfile.value.coverPicture
                ? 'var(--neutral-100)'
                : 'var(--neutral-70)'
            ,
            "data-testid": "qr-code-icon",
            onMouseenter: flipOff,
            onMouseleave: hoverFlip,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ path: '/qrcode' })))
          }, null, 8 /* PROPS */, ["color"])),
          _createVNode(TestnetLabel),
          (readOnlyMode.value)
            ? (_openBlock(), _createElementBlock("lukso-tag", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('profile_card.read_only')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["profile-section-back-background", coverPictureClasses.value.backdropFilter])
        }, [
          _createVNode(ProfileBackground, {
            "profile-background": currentProfile.value.coverPicture,
            height: 224,
            width: 360
          }, null, 8 /* PROPS */, ["profile-background"])
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ProfilePicture, {
            "frontend-profile": currentProfile.value,
            "with-identicon": true,
            size: "big",
            class: "margin-center"
          }, null, 8 /* PROPS */, ["frontend-profile"]),
          _createElementVNode("div", _hoisted_5, [
            (!currentProfile.value.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(truncateMiddle)(currentProfile.value.address)), 1 /* TEXT */))
              : (_openBlock(), _createBlock(UserName, {
                  key: 1,
                  profile: {
                name: currentProfile.value.name,
                address: currentProfile.value.address,
              },
                  "max-width": 210,
                  "has-at-sign": true,
                  "has-slice-address": true,
                  "name-class": "home-profile",
                  "address-class": "home-profile",
                  class: "is-justify-content-center"
                }, null, 8 /* PROPS */, ["profile"]))
          ]),
          (currentProfile.value.tags?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentProfile.value.tags, (tag, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: index,
                    class: "button is-secondary tag mx-2",
                    "data-testid": "tag",
                    name: "tag"
                  }, _toDisplayString(tag), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          (isTokenBalanceLoading.value)
            ? (_openBlock(), _createBlock(Skeleton, {
                key: 1,
                name: "loading-balance",
                width: "81",
                height: "28",
                class: "mt-4"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createCommentVNode(" mouse enter/leave callbacks prevent card from flipping when user sees balance tooltip "),
                  _createVNode(FormattedTokenAmount, {
                    onMouseenter: flipOff,
                    onMouseleave: hoverFlip,
                    class: "icon-button",
                    decimals: 18,
                    amount: balance.value,
                    symbol: _unref(preferencesStore).token.symbol,
                    offset: "12"
                  }, {
                    default: _withCtx(({ amount, symbol }) => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(amount), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(symbol), 1 /* TEXT */)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["amount", "symbol"])
                ])
              ]))
        ])
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(["profile-section-back flip-box-back", coverPictureClasses.value.lightBoxShadow])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["profile-section-back-background", coverPictureClasses.value.backdropFilter])
        }, [
          _createVNode(ProfileBackground, {
            "profile-background": currentProfile.value?.coverPicture,
            height: 224,
            width: 360,
            blur: !!currentProfile.value.coverPicture
          }, null, 8 /* PROPS */, ["profile-background", "blur"])
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["profile-section-back-foreground", !currentProfile.value.description ? 'no-description' : ''])
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(Tooltip, {
              value: _ctx.$t('profile.tooltip.expand'),
              "offset-distance": "0"
            }, {
              default: _withCtx(() => [
                _createVNode(SvgIcon, {
                  height: "24",
                  width: "24",
                  name: "expand",
                  color: "var(--neutral-100)",
                  "data-testid": "expanded",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'expanded' })))
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["value"]),
            _createVNode(UPWebsiteLink),
            (!readOnlyMode.value)
              ? (_openBlock(), _createBlock(Tooltip, {
                  key: 0,
                  value: _ctx.$t('profile.tooltip.edit'),
                  "offset-distance": "0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(SvgIcon, {
                      height: "24",
                      width: "24",
                      name: "edit",
                      color: "var(--neutral-100)",
                      "data-testid": "edit-profile",
                      onClick: openEditProfile
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('profile.info')), 1 /* TEXT */),
            _createVNode(ClipboardCopy, {
              value: currentProfile.value?.address,
              "has-hover-text": false,
              placement: "top",
              locked: "",
              "offset-distance": "20"
            }, {
              default: _withCtx(() => [
                _createElementVNode("input", {
                  ref: "profilePictureRef",
                  type: "text",
                  readonly: "",
                  value: currentProfile.value?.address,
                  class: "form-control input-outline is-align-items-center address-input mt-1"
                }, null, 8 /* PROPS */, _hoisted_16)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["value"]),
            _withDirectives(_createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(currentProfile.value?.description), 1 /* TEXT */)
            ], 512 /* NEED_PATCH */), [
              [_vShow, currentProfile.value?.description]
            ])
          ])
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 34 /* CLASS, NEED_HYDRATION */))
}
}

})